import { DatePicker, Form } from "antd";
import { ReactElement, useEffect, useState } from "react";

import "./take-action.scss";
import Label from "../label/label.component";
import CustomInput from "../custom-input/custom-input.component";
import TextArea from "antd/es/input/TextArea";
import moment from "moment";

interface TakeActionProps {
  label: string;
  action: "reject" | "approve";
  fieldName: string;
  errorName: string;
  date?: boolean;
  onCancel: (statusReason: string) => void;
  onSubmit: (transactionId: string) => void;
}

const TakeAction: React.FC<TakeActionProps> = ({
  label,
  action,
  fieldName,
  errorName,
  date = false,
  onCancel,
  onSubmit,
}: TakeActionProps): ReactElement => {
  const [form] = Form.useForm();
  const values = Form.useWatch([], form);
  const [submitForm, setSubmitForm] = useState(false);

  useEffect(() => {
    form.validateFields({ validateOnly: true }).then(
      () => {
        setSubmitForm(true);
      },
      () => {
        setSubmitForm(false);
      }
    );
  }, [values]);

  return (
    <section className="take-action-component-container flex flex-col py-30">
      <h3>Take action</h3>
      <Form form={form}>
        <div className="fields flex flex-col">
          <Label text={label} />
          <Form.Item
            name={fieldName}
            rules={[
              {
                required: true,
                message: `Please input ${errorName}!`,
              },
            ]}
          >
            {date ? (
              <DatePicker
                disabledDate={(current) =>
                  (current && current > moment().endOf("day")) ||
                  current < moment().subtract(1, "month").startOf("day")
                }
                showToday={false}
              />
            ) : action === "approve" ? (
              <CustomInput
                type="number"
                placeholder={`Enter ${label?.toLowerCase()}`}
              />
            ) : (
              <TextArea
                rows={4}
                placeholder={`Enter ${label?.toLowerCase()}`}
              />
            )}
          </Form.Item>
        </div>

        <div className="buttons-container flex align-center justify-space-between">
          <button
            className="cancel"
            onClick={() => onCancel(form.getFieldValue(fieldName))}
          >
            Cancel
          </button>
          <button
            disabled={!submitForm}
            onClick={() => onSubmit(form.getFieldValue(fieldName))}
          >
            Submit
          </button>
        </div>
      </Form>
    </section>
  );
};

export default TakeAction;
